import React from 'react';

const WizardSteps = ({ steps, currentStep, state, setState }) => {
	const handleStepClick = (stepIndex) => {
		// Only allow clicking on completed steps (previous steps)
		if (stepIndex + 1 < currentStep) {
			setState({
				...state,
				step: stepIndex + 1
			});
		}
	};

	return (
		<div className="wizard-steps">
			{steps.map((stepName, index) => (
				<div
					key={index}
					className={`wizard-step ${
						index + 1 === currentStep ? 'active' :
							index + 1 < currentStep ? 'completed' : ''
					}`}
					onClick={() => handleStepClick(index)}
					style={{
						cursor: index + 1 < currentStep ? 'pointer' : 'default'
					}}
				>
					<div className="step-number">{index + 1}</div>
					<span>{stepName}</span>
				</div>
			))}
		</div>
	);
};

export default WizardSteps;